<template lang="pug">
.start-stop-row(:class="rowClass")
  .start-stop-label(v-if="label")
    .start-stop-icon
      span.material-symbols-rounded.hi-18 {{ icon }}
    span {{ label }}
  InsightsStartStopTimeTrack(
    :start-time="startTime"
    :stop-time="stopTime"
    :scale-start="scaleStart"
    :scale-end="scaleEnd"
    :scale-label-count="scaleLabelCount"
  )
</template>

<script>
import InsightsStartStopTimeTrack from '~/components/insights/InsightsStartStopTimeTrack.vue';

export default {
  name: 'InsightsStartStopTimeRow',
  components: {
    InsightsStartStopTimeTrack,
  },
  props: {
    startTime: {
      type: Number,
      default: null,
    },
    stopTime: {
      type: Number,
      default: null,
    },
    scaleStart: {
      type: Number,
      required: true,
    },
    scaleEnd: {
      type: Number,
      required: true,
    },
    scaleLabelCount: {
      type: Number,
      required: true,
    },
    rowClass: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
  },
};
</script>
